import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@mono/ui-components';
import { toast } from 'sonner';
import { useRemoveMember } from '../../hooks/useProjects';
import { apiErrorMessage } from '../../lib/api/apiErrorMessage';
export function RemoveMemberDialog({ open, onOpenChange, projectId, member }) {
    const removeMember = useRemoveMember();
    const handleRemove = async ()=>{
        try {
            await removeMember.mutateAsync({
                projectId,
                userId: member.userId
            });
            toast.success(`${member.name} removed from project`);
            onOpenChange(false);
        } catch (error) {
            toast.error(apiErrorMessage(error, 'Failed to remove member'));
        }
    };
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(DialogContent, {
            className: "sm:max-w-[500px]",
            "data-testid": "remove-member-dialog",
            children: [
                /*#__PURE__*/ _jsxs(DialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            children: "Remove Member"
                        }),
                        /*#__PURE__*/ _jsxs(DialogDescription, {
                            children: [
                                "Are you sure you want to remove ",
                                /*#__PURE__*/ _jsx("strong", {
                                    children: member.name
                                }),
                                " from this project? They will lose access to all project files and data."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(DialogFooter, {
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: removeMember.isPending,
                            "aria-label": "Cancel removing member",
                            "data-testid": "remove-member-cancel-button",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            variant: "destructive",
                            onClick: handleRemove,
                            isLoading: removeMember.isPending,
                            "aria-label": `Remove ${member.name} from project`,
                            "data-testid": "remove-member-confirm-button",
                            children: "Remove Member"
                        })
                    ]
                })
            ]
        })
    });
}
